export default {
  title: {
    en: 'Odds Slippage Tolerance',
  },
  custom: {
    en: 'Custom',
  },
}
